export { useAdobeTargetComponentView } from './useAdobeTargetComponentView';
